import { createFileRoute } from '@tanstack/react-router';

import { AssessmentsPage } from '@/features/teacher/AssessmentsPage';

export const Route = createFileRoute('/_authed/teacher/assessments')({
  component: AssessmentsPage,
});
